import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=bc380de8&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"
import style0 from "./index2.vue?vue&type=style&index=0&id=bc380de8&prod&scoped=true&lang=scss"
import style1 from "./index2.vue?vue&type=style&index=1&id=bc380de8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc380de8",
  null
  
)

export default component.exports